import axios from 'axios';
import { cookies } from '../redux/sagas/auth.saga';

// Get API URL: runtime configuration has priority over build-time
const getApiUrl = () => {
    return (window._env_ && window._env_.REACT_APP_API_URL) || process.env.REACT_APP_API_URL || "http://localhost:8080";
};

export class RequestService {

    url = getApiUrl();

    constructor(name_entity) {
        this.url += `/${name_entity}`;
    }

    request = async (method = "", path = "", id = "", body = "", queryParams = "", isFormData = false) => {
        const requestOptions = {
            method: method || "get",
            url: this.url,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
            },
            responseType: 'json',

        };

        // If this is FormData, do not set Content-Type (the browser will set it automatically with boundary)
        if (!isFormData) {
            requestOptions.headers['Content-Type'] = 'application/json';
        }

        if (Object.keys(queryParams || {}).length > 0) requestOptions['params'] = queryParams;
        if (body) requestOptions['data'] = body;
        if (path) requestOptions.url = requestOptions.url + `/${path}`;
        if (id) requestOptions.url = requestOptions.url + '/' + id;
        const res = await axios(requestOptions);

        return await res;

    }

}




